import { memo } from 'react';
import { NotFoundTemplate } from 'components/templates/NotFoundTemplate';

type Props = {};

export const NotFoundPage = memo((_props: Props) => {
	return <NotFoundTemplate />;
});
